/* eslint-disable react/require-default-props */
/* eslint-disable react-hooks/exhaustive-deps */
import Calendar from 'components/molecules/calendar';
import ManagementTask from 'components/molecules/management_task';
import TaskFilter from 'components/molecules/task_filter';
import ToggleListCalendar from 'components/molecules/toggle_list_calendar';
import moment from 'moment';
import React, { Dispatch, SetStateAction, useEffect, useMemo, useRef, useState } from 'react';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import {
  getBiddingSummary,
  getManagementMembers,
  getTasks,
  deleteTasksBatch,
  updateTasksStatusBatch,
} from 'store/modules/management_store/actions';
import { showUndoToast } from 'store/modules/undo_toast_store/actions';
import { UndoToastState } from 'store/modules/undo_toast_store/types';
import BatchConfirmModal from 'components/atoms/batch_confirm_modal';
import BatchUpdateTasksModal from 'components/atoms/batch_update_tasks_modal';
import AffectedMembersSelect from 'components/atoms/affected_members_select';
import { ManagementState } from 'store/modules/management_store/types';
import Loader from 'components/atoms/loader';
import TextFilter from 'components/atoms/text_filter';
import { BiddingData } from 'store/modules/bidding_store/types';
import companyId from 'services/company_id';
import { ProfileState } from 'store/modules/profile_store/types';
import tabId from 'services/tabId';
import createTrack from 'services/actions/tracker_actions';
import { getDownloadBiddings } from 'services/actions/bidding_actions';
import { toggleSelected } from 'services/toggleSelected';
import { useReactToPrint } from 'react-to-print';
import ItemShare from 'components/atoms/item_share';
import ItemTools from 'components/molecules/item_tools';
import SelectButton from 'components/atoms/select_button';
import Pagination from 'components/atoms/pagination';
import PerPageOptions from 'components/atoms/per_page_options';
import useDebouncedValue from 'hooks/useDebouncedValue';
import useRefetchOnModalMutation from 'hooks/useRefetchOnModalMutation';
import { taskColor, taskDisplay } from 'services/task_appearance';
import { ContainerTask } from './styles';
import { datatableColumns, datatableData } from './datatable_list';

interface TasksPageProps {
  bidding?: BiddingData | null;
  source?: string;
}

const DEFAULT_PER_PAGE = 20;
const NO_MATCH_MESSAGE = 'Nenhum item dos membros escolhidos está entre os selecionados.';
const NOT_OWNED_MESSAGE =
  'Nenhuma das tarefas selecionadas foi criada por você nem tem você como responsável.';
const RESPONSIBLE_INVALID_MESSAGE =
  'O responsável escolhido não está mais ativo na empresa. Escolha outro.';

const buildBatchResultMessage = (
  action: 'remove' | 'update',
  requested: number,
  affected: number | null,
  isCompanyView: boolean,
) => {
  const done = affected ?? requested;
  const singular = action === 'remove' ? 'removida' : 'atualizada';
  const plural = action === 'remove' ? 'removidas' : 'atualizadas';
  const notOwnedOne = isCompanyView ? 'não é dos membros escolhidos' : 'não é sua';
  const notOwnedMany = isCompanyView ? 'não são dos membros escolhidos' : 'não são suas';

  if (done >= requested) return done === 1 ? `1 tarefa ${singular}.` : `${done} tarefas ${plural}.`;
  if (done === 0) {
    return `Nenhuma das tarefas selecionadas mudou: ${notOwnedMany} ou já estavam assim.`;
  }

  const left = requested - done;
  let reason: string;
  if (action === 'remove') {
    reason = left === 1 ? `1 ${notOwnedOne}.` : `As outras ${left} ${notOwnedMany}.`;
  } else {
    reason =
      left === 1
        ? `1 não mudou: ${notOwnedOne} ou já estava assim.`
        : `As outras ${left} não mudaram: ${notOwnedMany} ou já estavam assim.`;
  }
  return `${done} de ${requested} tarefas ${plural}. ${reason}`;
};

const TasksPage = (props: TasksPageProps) => {
  const { source = 'management', bidding = null } = props;
  const dispatch = useDispatch();

  const { management, request } = useSelector<ApplicationState, ManagementState>(
    (state) => state.session.management,
  );

  const taskList = bidding ? management.bidding_tasks : management.tasks;
  const taskListTotal = bidding
    ? management.bidding_tasks_total_entries
    : management.tasks_total_entries;

  const mountedRef = useRef<boolean>(false);
  const [filterPageType, setFilterPageType] = useState<string>('List');
  const [textFilterValue, setTextFilterValue] = useState<string>('');
  const debouncedText = useDebouncedValue(textFilterValue, 400);

  const [page, setPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(DEFAULT_PER_PAGE);

  const perPageOptions = [
    { value: 20, label: 20 },
    { value: 40, label: 40 },
    { value: 50, label: 50 },
    { value: 60, label: 60 },
    { value: 80, label: 80 },
    { value: 100, label: 100 },
  ];

  const handlePerPageChange = (value?: number) => {
    setPerPage(value || DEFAULT_PER_PAGE);
    setPage(1);
  };

  const [filterLate, setFilterLate] = useState<boolean>(true);
  const [filterToday, setFilterToday] = useState<boolean>(true);
  const [filterFuture, setFilterFuture] = useState<boolean>(true);
  const [filterFinished, setFilterFinished] = useState<boolean>(false);
  const [selectedTaskId, setSelectedTaskId] = useState<number>(-1);
  const [modalManagementTaskOpened, setModalManagementTaskOpened] = useState<boolean>(false);
  const [modalCreateTaskOpened, setModalCreateTaskOpened] = useState<boolean>(false);
  const [wholePageSelected, setWholePageSelected] = useState<boolean>(false);
  const [selectedTasks, setSelectedTasks] = useState<Array<number>>([]);
  const [scrollToolsClass, setScrollToolsClass] = useState<string>('');
  const [showShareWindow, setShowShareWindow] = useState<boolean>(false);
  const [showBatchDeleteModal, setShowBatchDeleteModal] = useState<boolean>(false);
  const [showBatchUpdateStatusModal, setShowBatchUpdateStatusModal] = useState<boolean>(false);
  const [batchRequestedCount, setBatchRequestedCount] = useState<number>(0);
  const [batchRemovedCount, setBatchRemovedCount] = useState<number | null>(null);
  const [batchUpdatedCount, setBatchUpdatedCount] = useState<number | null>(null);
  const [batchErrorMessage, setBatchErrorMessage] = useState<string | undefined>(undefined);
  const [selectedMemberIds, setSelectedMemberIds] = useState<Array<number> | null>(null);
  const componentRef = useRef() as React.MutableRefObject<HTMLInputElement>;

  const { lastUndo } = useSelector<ApplicationState, UndoToastState>(
    (state) => state.session.undoToast,
  );
  const initialUndoAtRef = useRef<number | undefined>(lastUndo?.at);

  const deadlineFilter = useMemo<Array<string>>(() => {
    const out: Array<string> = [];
    if (filterLate) out.push('late');
    if (filterToday) out.push('today');
    if (filterFuture) out.push('future');
    if (filterFinished) out.push('finished');
    return out;
  }, [filterLate, filterToday, filterFuture, filterFinished]);

  const totalEntries = taskListTotal || taskList?.length || 0;

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const isCompanyView = management?.filtered_by === 'client';
  const canShowDeleteButton = isCompanyView ? !!profile.consultant_login : !!profile.alfa_tester;
  const canShowUpdateStatusButton = canShowDeleteButton;

  const selectedTaskList = (taskList || []).filter((task) => selectedTasks.includes(task.id));
  const taskOwnerMemberIds =
    management.members?.companyId === companyId(profile)
      ? [...management.members.active, ...management.members.inactive]
          .map((member) => member.id)
          .filter((id) =>
            selectedTaskList.some(
              (task) => task.created_by_id === id || task.responsible_id === id,
            ),
          )
      : [];
  const affectedMemberIds = selectedMemberIds ?? taskOwnerMemberIds;
  const batchChoiceBlocked = isCompanyView && affectedMemberIds.length === 0;

  const openBatchModal = (
    setModalOpened: Dispatch<SetStateAction<boolean>>,
    loadMembers = isCompanyView,
  ) => {
    setSelectedMemberIds(null);
    setBatchErrorMessage(undefined);
    if (loadMembers && management.members?.companyId !== companyId(profile)) {
      dispatch(getManagementMembers(companyId(profile)));
    }
    setModalOpened(true);
  };

  const batchChoice = () => ({ memberIds: isCompanyView ? affectedMemberIds : undefined });

  const selectedFinishedCount = selectedTaskList.filter(
    (task) => task.status_task_id === 'finished',
  ).length;
  const selectedInProgressCount = selectedTaskList.filter(
    (task) => task.status_task_id !== 'finished',
  ).length;

  const batchChoiceFields = isCompanyView ? (
    <AffectedMembersSelect
      active={management.members?.active || []}
      inactive={management.members?.inactive || []}
      value={affectedMemberIds}
      onChange={setSelectedMemberIds}
      currentUserId={profile.id}
      isLoading={!!request.get_management_members?.loading}
    />
  ) : null;

  const displayFlags = { filterLate, filterToday, filterFuture, filterFinished };
  const tasksEvents = (taskList || []).map((task) => {
    const finished = task.status_task_id === 'finished';
    return {
      id: task.id?.toString(),
      title: task.title,
      start: moment(moment.parseZone(task.deadline).format('YYYY-MM-DDTHH:mm:ss')).toDate(),
      className: taskColor(task.deadline, finished),
      description: `${task.bidding?.edital} - ${task.bidding?.public_body?.nome} - ${task.description}`,
      type: 'task',
      display: taskDisplay(task.deadline, finished, displayFlags),
    };
  });

  const downloadFile = (
    fileExtension: string,
    biddings_managed?: boolean,
    biddings_finished?: boolean,
    biddings_progress?: boolean,
    biddings_tasks?: boolean,
  ) => {
    const biddingIds = (taskList || [])
      .filter((item) => selectedTasks.includes(item.id))
      .map((item) => item.bidding_id);

    getDownloadBiddings(
      fileExtension,
      'licitacoes',
      biddingIds,
      selectedTasks?.length,
      companyId(profile),
      biddings_managed,
      biddings_finished,
      biddings_progress,
      selectedTasks,
      biddings_tasks,
      false,
    );
  };

  const visibleList = taskList || [];
  const selectedTask = visibleList.find((task) => task.id === selectedTaskId);

  const toggleSelectedTasks = (id: number, updateAll = false) => {
    toggleSelected({
      id,
      selectedList: selectedTasks,
      setSelectedList: setSelectedTasks,
      sourceList: visibleList,
      wholePageSelected,
      updateAll,
    });
  };
  const handleShare = () => {
    setShowShareWindow(!showShareWindow);
  };
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: 'conlicitacao',
  });

  const wrapStatusSetter =
    (setter: Dispatch<SetStateAction<boolean>>): Dispatch<SetStateAction<boolean>> =>
    (next) => {
      setter(next);
      setPage(1);
    };
  const handleTextFilter: Dispatch<SetStateAction<string>> = (value) => {
    setTextFilterValue(value);
    setPage(1);
  };

  const fetchTasks = () => {
    const scope = bidding ? 'client' : management.filtered_by;
    const biddingId = bidding ? bidding.id : null;
    dispatch(
      getTasks(scope, companyId(profile), biddingId, {
        page,
        per_page: perPage,
        q: debouncedText || undefined,
        deadline_filter: deadlineFilter,
      }),
    );
  };

  useEffect(() => {
    const windowDiv = document.getElementById('windowDiv');
    if (!windowDiv) return undefined;
    const handler = () => {
      setScrollToolsClass(windowDiv.scrollTop > 10 ? 'border-bottom' : '');
    };
    windowDiv.addEventListener('scroll', handler);
    return () => windowDiv.removeEventListener('scroll', handler);
  }, []);

  useEffect(() => {
    if (!taskList) return;
    setWholePageSelected(
      visibleList.length > 0 && visibleList.every((item) => selectedTasks.includes(item.id)),
    );
  }, [selectedTasks, taskList, visibleList]);

  useEffect(() => {
    fetchTasks();
    setSelectedTasks([]);
    setWholePageSelected(false);
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, [
    debouncedText,
    deadlineFilter,
    page,
    perPage,
    management.filtered_by,
    profile.currentCompany[tabId()],
    bidding?.id,
  ]);

  useEffect(() => {
    if (!bidding) return;
    dispatch(getBiddingSummary(bidding.id, companyId(profile)));
  }, [bidding?.id]);

  useEffect(() => {
    if (!lastUndo || lastUndo.at === initialUndoAtRef.current) return;
    if (lastUndo.type === 'favorites') return;
    fetchTasks();
  }, [lastUndo?.at]);

  useEffect(() => {
    if (modalManagementTaskOpened) return;
    setSelectedTaskId(-1);
  }, [modalManagementTaskOpened]);

  useEffect(() => {
    if (selectedTaskId >= 0) setModalManagementTaskOpened(true);
  }, [selectedTaskId]);

  const refreshAfterTaskMutation = () => {
    setSelectedTasks([]);
    setWholePageSelected(false);
    if (bidding) dispatch(getBiddingSummary(bidding.id, companyId(profile)));
  };

  useRefetchOnModalMutation(modalCreateTaskOpened, [request.create_tasks?.loaded], () => {
    refreshAfterTaskMutation();
    if (page !== 1) setPage(1);
    else fetchTasks();
  });

  useRefetchOnModalMutation(
    modalManagementTaskOpened,
    [
      request.update_tasks?.loaded,
      request.delete_task?.loaded,
      request.create_task_comment?.loaded,
      request.delete_task_comment?.loaded,
      request.create_task_attachment?.loaded,
    ],
    () => {
      refreshAfterTaskMutation();
      fetchTasks();
    },
  );

  const selectedBiddings = visibleList.filter((b) => selectedTasks.includes(b.id));
  const selectedTaskBiddingIds = Array.from(
    new Set(selectedBiddings.map((task) => task.bidding_id)),
  );
  const printColumns = [
    ...datatableColumns(
      visibleList,
      () => {},
      () => {},
      'tasks',
    ).filter((col) => col.name !== ''),
    {
      name: 'Status',
      selector: (row: any) => (row.read ? 'Lido' : 'Não lido'),
      cell: (row: any) => (
        <div style={{ fontWeight: row.read ? 'normal' : 'bold' }}>
          {row.read ? 'Lido' : 'Não lido'}
        </div>
      ),
      sortable: true,
      width: '100px',
    },
  ];

  const customStyles = {
    headCells: { style: { paddingLeft: '10px', paddingRight: '10px' } },
    cells: { style: { paddingLeft: '10px', paddingRight: '10px' } },
    rows: { style: { fontSize: '14px' } },
  };

  return (
    <div className="col-12">
      <div className="py-3 d-md-flex align-items-center">
        <ToggleListCalendar filterPageType={filterPageType} setFilterPageType={setFilterPageType} />
        <TextFilter textFilterValue={textFilterValue} setTextFilterValue={handleTextFilter} />
        <TaskFilter
          filterLate={filterLate}
          setFilterLate={wrapStatusSetter(setFilterLate)}
          filterToday={filterToday}
          setFilterToday={wrapStatusSetter(setFilterToday)}
          filterFuture={filterFuture}
          setFilterFuture={wrapStatusSetter(setFilterFuture)}
          filterFinished={filterFinished}
          setFilterFinished={wrapStatusSetter(setFilterFinished)}
          source={source}
          biddingId={source === 'details' ? bidding?.id : null}
        />
        {source === 'details' && bidding && !!management.bidding_summary[bidding.id]?.is_managed && (
          <button
            type="button"
            className="btn ml-auto btn-primary btn-sm mb-1"
            onClick={() => {
              setModalCreateTaskOpened(true);
              createTrack('Card - Adicinou tarefa', { fonte: 'biddingDetails' });
            }}
          >
            Adicionar tarefa
          </button>
        )}
      </div>
      {filterPageType === 'List' && (
        <ContainerTask>
          {request.get_tasks.loading && <Loader />}
          <div className={`row list-tools py-1 ${scrollToolsClass}`}>
            <div className="position-relative col-md-6 d-block py-3 px-2 tour-remove-favorites-select-begin">
              <SelectButton
                isChecked={wholePageSelected}
                id={0}
                toggleSelected={toggleSelectedTasks}
                text="Selecionar página"
              />
              {selectedTasks?.length > 0 && (
                <div className="itemToolsSelected ml-3">
                  {selectedTasks?.length}{' '}
                  {selectedTasks?.length === 1
                    ? 'registro selecionado.'
                    : 'registros selecionados.'}
                  <button
                    type="button"
                    className="btn btn-link m-0 py-0 px-1 border-0"
                    onClick={() => setSelectedTasks([])}
                  >
                    Limpar seleção.
                  </button>
                </div>
              )}
            </div>
            <ItemTools
              enabledButtons={selectedTasks?.length > 0}
              biddings_tasks
              disabledPopoverLabel="a tarefa"
              downloadFile={downloadFile}
              handleShare={handleShare}
              handlePrint={handlePrint}
              showDeleteButton={canShowDeleteButton}
              handleDelete={
                canShowDeleteButton ? () => openBatchModal(setShowBatchDeleteModal) : undefined
              }
              showUpdateStatusButton={canShowUpdateStatusButton}
              handleUpdateStatus={
                canShowUpdateStatusButton
                  ? () => openBatchModal(setShowBatchUpdateStatusModal, true)
                  : undefined
              }
            />
            {showShareWindow && (
              <ItemShare
                setShowShareWindow={setShowShareWindow}
                selectedItems={selectedTaskBiddingIds}
              />
            )}
            {showBatchDeleteModal && (
              <BatchConfirmModal
                modalOpened={showBatchDeleteModal}
                setModalOpened={setShowBatchDeleteModal}
                title="Remover tarefas"
                message={
                  selectedTasks.length === 1
                    ? 'Tem certeza que deseja remover esta tarefa?'
                    : `Tem certeza que deseja remover ${selectedTasks.length} tarefas?`
                }
                confirmLabel={
                  selectedTasks.length === 1
                    ? 'Remover Tarefa'
                    : `Remover ${selectedTasks.length} Tarefas`
                }
                successMessage={buildBatchResultMessage(
                  'remove',
                  batchRequestedCount,
                  batchRemovedCount,
                  isCompanyView,
                )}
                errorMessage={batchErrorMessage || 'Erro ao remover as tarefas.'}
                variant="danger"
                isLoading={request.delete_task.loading}
                isLoaded={request.delete_task.loaded}
                isError={request.delete_task.error}
                confirmBlocked={batchChoiceBlocked}
                onConfirm={() => {
                  createTrack('Gestão de Licitações - Removeu tarefas em lote');
                  setBatchRequestedCount(selectedTasks.length);
                  setBatchRemovedCount(null);
                  setBatchErrorMessage(undefined);
                  setSelectedMemberIds(affectedMemberIds);
                  const result: any = dispatch(
                    deleteTasksBatch(
                      selectedTasks,
                      companyId(profile),
                      management?.filtered_by,
                      batchChoice(),
                    ),
                  );
                  if (result && typeof result.then === 'function') {
                    result.then((response: any) => {
                      if (response?.status === 404) {
                        setBatchErrorMessage(isCompanyView ? NO_MATCH_MESSAGE : NOT_OWNED_MESSAGE);
                      }
                      if (!response || response.status >= 400) return;
                      const ids = response?.data?.removed_task_ids;
                      const deletedAt = response?.data?.deleted_at;
                      if (Array.isArray(ids)) setBatchRemovedCount(ids.length);
                      if (Array.isArray(ids) && ids.length > 0 && deletedAt) {
                        const message =
                          ids.length === 1
                            ? '1 tarefa removida.'
                            : `${ids.length} tarefas removidas.`;
                        dispatch(
                          showUndoToast({
                            type: 'tasks',
                            ids,
                            deletedAt,
                            message,
                            scope: management?.filtered_by,
                            companyId: companyId(profile),
                          }),
                        );
                      }
                      fetchTasks();
                    });
                  }
                }}
                onSuccess={() => setSelectedTasks([])}
              >
                {batchChoiceFields}
              </BatchConfirmModal>
            )}
            {showBatchUpdateStatusModal && (
              <BatchUpdateTasksModal
                modalOpened={showBatchUpdateStatusModal}
                setModalOpened={setShowBatchUpdateStatusModal}
                selectedCount={selectedTasks.length}
                inProgressCount={selectedInProgressCount}
                finishedCount={selectedFinishedCount}
                isLoading={!!request.update_tasks_status_batch?.loading}
                isLoaded={!!request.update_tasks_status_batch?.loaded}
                isError={!!request.update_tasks_status_batch?.error}
                successMessage={buildBatchResultMessage(
                  'update',
                  batchRequestedCount,
                  batchUpdatedCount,
                  isCompanyView,
                )}
                errorMessage={batchErrorMessage}
                confirmBlocked={batchChoiceBlocked}
                activeMembers={
                  management.members?.companyId === companyId(profile)
                    ? management.members.active
                    : []
                }
                membersLoading={!!request.get_management_members?.loading}
                currentUserId={profile.id}
                onConfirm={(statusChange, deadline, responsible) => {
                  createTrack('Gestão de Licitações - Alterou status de tarefas em lote');
                  setBatchRequestedCount(selectedTasks.length);
                  setBatchUpdatedCount(null);
                  setBatchErrorMessage(undefined);
                  setSelectedMemberIds(affectedMemberIds);
                  const result: any = dispatch(
                    updateTasksStatusBatch(
                      selectedTasks,
                      { statusChange, deadline, responsible },
                      companyId(profile),
                      management?.filtered_by,
                      batchChoice(),
                    ),
                  );
                  if (result && typeof result.then === 'function') {
                    result.then((response: any) => {
                      if (response?.status === 404) {
                        setBatchErrorMessage(isCompanyView ? NO_MATCH_MESSAGE : NOT_OWNED_MESSAGE);
                      }
                      if (response?.data?.error === 'responsible_invalid') {
                        setBatchErrorMessage(RESPONSIBLE_INVALID_MESSAGE);
                        dispatch(getManagementMembers(companyId(profile)));
                      }
                      if (!response || response.status >= 400) return;
                      const ids = response?.data?.updated_task_ids;
                      const undoToken = response?.data?.undo_token;
                      if (Array.isArray(ids)) setBatchUpdatedCount(ids.length);
                      if (Array.isArray(ids) && ids.length > 0 && undoToken) {
                        dispatch(
                          showUndoToast({
                            type: 'tasks_status',
                            ids,
                            undoToken,
                            message:
                              ids.length === 1
                                ? '1 tarefa atualizada.'
                                : `${ids.length} tarefas atualizadas.`,
                            scope: management?.filtered_by,
                            companyId: companyId(profile),
                          }),
                        );
                      }
                      fetchTasks();
                    });
                  }
                }}
                onSuccess={() => setSelectedTasks([])}
              >
                {batchChoiceFields}
              </BatchUpdateTasksModal>
            )}
            {request.get_tasks.loaded && (
              <div className="row mb-3 px-4">
                <PerPageOptions
                  options={perPageOptions}
                  postsPerPage={perPage}
                  handleSelect={handlePerPageChange}
                />
              </div>
            )}
            {request.get_tasks.loaded && (
              <DataTable
                columns={datatableColumns(
                  visibleList,
                  setSelectedTaskId,
                  toggleSelectedTasks,
                  source,
                )}
                data={datatableData(visibleList, companyId(profile), selectedTasks, source)}
                customStyles={customStyles}
                noDataComponent={<div className="p-5">Você não possui tarefas.</div>}
              />
            )}
            {request.get_tasks.loaded && totalEntries > perPage && (
              <div className="col-12 d-flex justify-content-end mt-4">
                <Pagination
                  postsPerPage={perPage}
                  totalPosts={totalEntries}
                  paginate={(p) => setPage(p)}
                  currentPage={page}
                  firstAndLastPage
                />
              </div>
            )}
          </div>
        </ContainerTask>
      )}
      {filterPageType === 'Calendar' && (
        <div>
          {request.get_tasks.loading && <Loader />}
          {request.get_tasks.loaded && (
            <Calendar eventsList={tasksEvents} setSelectedTaskId={setSelectedTaskId} />
          )}
        </div>
      )}
      {modalManagementTaskOpened && selectedTask && (
        <ManagementTask
          modalManagementTaskOpened={modalManagementTaskOpened}
          setModalManagementTaskOpened={setModalManagementTaskOpened}
          bidding={selectedTask.bidding}
          taskType="task"
          task={selectedTask}
        />
      )}
      {modalCreateTaskOpened && bidding && (
        <ManagementTask
          modalManagementTaskOpened={modalCreateTaskOpened}
          setModalManagementTaskOpened={setModalCreateTaskOpened}
          bidding={bidding}
          taskType="task"
        />
      )}
      <div style={{ display: 'none' }}>
        <div ref={componentRef}>
          <DataTable
            columns={printColumns}
            data={datatableData(selectedBiddings, companyId(profile), selectedTasks)}
            customStyles={{
              rows: { style: { fontSize: '12px' } },
              headCells: { style: { fontWeight: 'bold' } },
            }}
            pagination={false}
            selectableRows={false}
            dense
          />
        </div>
      </div>
    </div>
  );
};

export default TasksPage;
